import React, { useEffect, useRef, useState } from 'react'
import { AutoComplete } from 'primereact/autocomplete'

import '../../Entrega/Cte/Partes/SelectClienteTp.css'

const comRotulo = item =>
  item ? { ...item, rotulo: `${item.codigo_formatado} - ${item.descricao}` } : ''

// Busca no servidor por código (com ou sem pontos) ou por palavras da descrição das listas oficiais
export default function SelectCodigoNfse({
  label,
  value,
  buscar,
  onChange,
  onError,
  placeholder,
  dica,
}) {
  const [valor, setValor] = useState(comRotulo(value))
  const [sugestoes, setSugestoes] = useState([])
  const autoComplete = useRef(null)
  const codigo = value ? value.codigo : null

  useEffect(() => {
    setValor(comRotulo(value))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codigo])

  // Com o painel no body, as descrições longas da lista oficial o esticam até a largura da tela.
  // Ele começa no topo para não abrir a barra de rolagem da página (que desloca o modal) antes de ser posicionado
  const limitarLarguraDoPainel = () => {
    const instancia = autoComplete.current
    if (!instancia || !instancia.panel || !instancia.panel.element || !instancia.inputEl) return
    const painel = instancia.panel.element
    painel.style.boxSizing = 'border-box'
    painel.style.maxWidth = `${instancia.inputEl.offsetWidth}px`
    if (!painel.offsetParent) {
      painel.style.top = '0px'
      painel.style.left = '0px'
    }
  }

  const completar = async event => {
    limitarLarguraDoPainel()
    try {
      const itens = await buscar(event.query)
      setSugestoes((itens || []).map(comRotulo))
    } catch (error) {
      setSugestoes([])
      onError(error)
    }
  }

  return (
    <div className="SelectClienteTp">
      <label className="autocomplete-label">{label}</label>
      <AutoComplete
        ref={autoComplete}
        value={valor}
        suggestions={sugestoes}
        completeMethod={completar}
        field="rotulo"
        itemTemplate={item => (
          <span>
            <strong>{item.codigo_formatado}</strong> - {item.descricao}
          </span>
        )}
        dropdown={true}
        dropdownMode="blank"
        minLength={1}
        delay={300}
        placeholder={placeholder}
        appendTo={document.body}
        onChange={event => {
          setValor(event.value)
          if (!event.value) onChange(null)
        }}
        onSelect={event => {
          setValor(event.value)
          onChange(event.value)
        }}
      />
      {dica && <span className="autocomplete-hint">{dica}</span>}
    </div>
  )
}
